import { Alert } from './alert.type';

export interface AnAlertItemsByPosition {
  left?: Array<Alert>;
  center?: Array<Alert>;
  right?: Array<Alert>;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
